import { mpLoginApi, QueryUserIsBindApi } from "@/api/login";

import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(), // 用户token
    enrollState: 100, //注册状态 100未查询   0：未注册   1：已注册

    userName:"",//用户名
    realName:"",//真实姓名
    headUrl:"",//头像
    phone:"",//手机号
    openId:"",//微信openId
    mpOpenId:"",//公众号openId
    unionId:"",//公众平台唯一id
    status:"",//状态 0：失效 1：有效
    role:"",//SuperAdmin 超管、Admin 管理员、Customer 客户
    landPageRoute:"",

    

  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ENROLLSTATE: (state, enrollState) => {
      state.enrollState = enrollState
    },
     SET_USERNAME: (state, userName) => {
      state.userName = userName
    },
     SET_REALNAME: (state, name) => {
      state.realName = name
    },
     SET_HEADURL: (state, url) => {
      state.headUrl = url
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },

    SET_OPENID: (state, id) => {
      state.openId = id
    },
    SET_MPOPENID: (state, id) => {
      state.mpOpenId = id
    },
    SET_UNIONID: (state, id) => {
      state.unionId = id
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },

    SET_LANDPAGEROUTE: (state, landPageRoute) => {
      state.landPageRoute = landPageRoute
    },




  },

  actions: {    
    // 模拟数据
    debugData({ commit }) {
      return new Promise(resolve => {
        let token ='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1dWlkIjoiMjAyNjgzOTQ3ODUzNDAxNzAyNCIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL25hbWVpZGVudGlmaWVyIjoiMjMiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoibnVsbCIsImV4cCI6MTc3MjI0Mzk2MywiaXNzIjoiVE0uQmFzZUFwaSIsImF1ZCI6IlRNLkJhc2VBcGkifQ.h0UWl3ZBx28TiPDawCVIbBOozL4glnUybt5QMu4n7rs'

        commit('SET_TOKEN', token)
        setToken(token)
        resolve()
      })
    },

    // 公众号登录
    LoginMp({ commit }, para) {
      return new Promise((resolve, reject) => {
        mpLoginApi(para).then(res => {
          if (res.code === 200) {
            commit('SET_TOKEN', res.data.token);
            // commit('SET_MERID', res.data.merId);
            setToken(res.data.token)
            // setToken(data.data.merId)
            resolve(res)
          } else {
            resolve(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询是否注册绑定
    QueryUserIsBind({ commit }) {
      return new Promise((resolve, reject) => {
        QueryUserIsBindApi().then(res => {
          if (res.code === 200) {
            var data=res.data;
            commit('SET_ENROLLSTATE',  data.isRegister || 0);
            commit('SET_USERNAME',  data.userName || '');
            commit('SET_REALNAME', data.realName||'');
            commit('SET_HEADURL',  data.headUrl || '');
            commit('SET_PHONE', data.phone||'');
            commit('SET_OPENID',  data.openId || '');
            commit('SET_MPOPENID', data.mpOpenId||'');
            commit('SET_UNIONID',  data.unionId || '');
            commit('SET_STATUS', data.status||'');
            commit('SET_ROLE', data.role||'');


            resolve(res)
          } else {
            resolve(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },


    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ENROLLSTATE',  100);
        removeToken()
        resolve()
      })
    },

    //设置登录前访问页面
    setLandPage({ commit }, route) {
      try{
        //只有支付才跳回原来页面
        if(route.indexOf("/orderpay")<0){
          route="/";
        }
      }catch(err){
        console.log(err)
      }
      commit('SET_LANDPAGEROUTE', route);
    }


  }
}

export default user
